import { clickupAPI } from '../../utils/api/clickup';
import { useState, useEffect } from 'react';

const useTaskData = (taskID) => {
  const [taskData, setClickupData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchClickupTaskData = async () => {
      setLoading(true); 
      try {
        const data = await clickupAPI({action: 'getTaskData', taskId: taskID});
        setClickupData(data);
      } catch (error) {
        console.error('Error fetching task data:', error);
        setError(error);
      } finally {
        setLoading(false); 
      } 
    };

    fetchClickupTaskData();

  }, [taskID]); 

  return { taskData, loading, error };
};

export default useTaskData;

